import LoginComponent from "components/admin/Login";

const LoginAdminPage = () => {
  return (
    <div className="">
      <LoginComponent />
    </div>
  );
};

export default LoginAdminPage;
